const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.4f5dd5d8a7c5abbc11a1909f13a33a3f.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.39fea8f883049eb7fa902c12aea090a5.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.61c0afa4d6cfe69c3426491ca029c09b.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.f4b9791536ba1e3079e6eb6af3db9b6b.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.560975cea60a27ee66ff80d87fae6030.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.c99a9b6036508bcdd3baeb21b50476a0.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.c5e395f7199e5c17d0a8944edc371776.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.785ce7d37fcc02d10b89ef3fb2f993c5.min.css',
        versioned: 'step-indicator.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.b5afcccef5435c16d728b78d7fbba1d9.min.css',
        versioned: 'standard-tile.min.css'
    },
    standardHero: {
        hashed: 'standard-hero.e79b849056e7a0ec4504ff4e287ec130.min.css',
        versioned: 'standard-hero.min.css'
    },
    standardBanner: {
        hashed: 'standard-banner.76bc30b36139633dd673a261ac2d9d3e.min.css',
        versioned: 'standard-banner.min.css'
    },
    spinner: {
        hashed: 'spinner.ebb3caa7ea719bb5002c40745de6e207.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.074a29b8405135dfd1091c3bb5314977.min.css',
        versioned: 'selection-set.min.css'
    },
    secondaryTile: {
        hashed: 'secondary-tile.4332819d0449b47acd307fe626b9e08f.min.css',
        versioned: 'secondary-tile.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.765b21f1d1b20b188f366da8ceabc1c4.min.css',
        versioned: 'ratings-stars.min.css'
    },
    promoBar: {
        hashed: 'promo-bar.974e7cddabfa7c5fb54f62c8e533a64e.min.css',
        versioned: 'promo-bar.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.da40494ed0231c961d7aeb1734c37253.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.0284b880136eb16a3cd2f09b0fb6b033.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.a99b4fa5727591954286b863a1b89a45.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.eb6f939aa8b8e97cf1fefc2609899e3b.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.bd819670aad044a9b3bfc53d16c404e2.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.fc43c44c3b805dfe62a685b72e5fb584.min.css',
        versioned: 'modal-dialog.min.css'
    },
    menu: {
        hashed: 'menu.818a0900b92cbef02394b26d263bb1ae.min.css',
        versioned: 'menu.min.css'
    },
    listbox: {
        hashed: 'listbox.0f5f8506e1221ed24a970120c7af2c66.min.css',
        versioned: 'listbox.min.css'
    },
    legacyPopover: {
        hashed: 'legacy-popover.75a905ca99892ad5f0b58f21af88bc0c.min.css',
        versioned: 'legacy-popover.min.css'
    },
    legacyModalDialog: {
        hashed: 'legacy-modal-dialog.c0f488987db84970fef0af293ba22492.min.css',
        versioned: 'legacy-modal-dialog.min.css'
    },
    legacyListbox: {
        hashed: 'legacy-listbox.0952e69b082273b828b7d18b5600f2ff.min.css',
        versioned: 'legacy-listbox.min.css'
    },
    legacyCombobox: {
        hashed: 'legacy-combobox.cb1789f3ca06194258114a6c8d0d0b19.min.css',
        versioned: 'legacy-combobox.min.css'
    },
    icon: {
        hashed: 'icon.de0c3f374d63ed3869be4238010afb64.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.210e9d83e2e978cb40c8da2171aeafa1.min.css',
        versioned: 'grid.min.css'
    },
    fieldSet: {
        hashed: 'field-set.b4b1adfeffa5420eb5d5f1e46900d413.min.css',
        versioned: 'field-set.min.css'
    },
    embeddedTextHero: {
        hashed: 'embedded-text-hero.c16a5e17e2487ffc4a4c616e7111d6c9.min.css',
        versioned: 'embedded-text-hero.min.css'
    },
    detailsBanner: {
        hashed: 'details-banner.4ae73a272f89095f48bf5cd8aec94acf.min.css',
        versioned: 'details-banner.min.css'
    },
    controlIcon: {
        hashed: 'control-icon.1be7da330ecf24ecf63997a73b5d299b.min.css',
        versioned: 'control-icon.min.css'
    },
    combobox: {
        hashed: 'combobox.5e269579fb14995ac545fea61c46bf72.min.css',
        versioned: 'combobox.min.css'
    },
    carousel: {
        hashed: 'carousel.391c93addb152518d000feb0e3c86985.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.45fb2661fecc10dd133dca292681e746.min.css',
        versioned: 'button.min.css'
    },
    banner: {
        hashed: 'banner.3ed268f1d7091421ed4411d92fe41a64.min.css',
        versioned: 'banner.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.2d2abd28e42d3eb56c9fbdd9b576caef.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.7733674f32b1cf6b74b80d55239b2d45.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.dabd7527487aee11e20b7e7142ac68f5.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
